import { render, staticRenderFns } from "./question-06.vue?vue&type=template&id=d3d74ddc&scoped=true&lang=pug"
var script = {}
import style0 from "./question-06.vue?vue&type=style&index=0&id=d3d74ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d74ddc",
  null
  
)

export default component.exports